import { useTranslation } from "react-i18next";
import skills from "../../data/skills.json";
import { capitalize } from "../../utils";
import { Skill } from "../SkillAnchor";
import Title from "./Title";

const SHOW_SKILLS = [
	"angular",
	"bootstrap",
	"django",
	"flask",
	"git",
	"go",
	"javascript",
	"openjdk",
	"python",
	"react",
	"tailwindcss",
	"typescript",
];

export default function Skills() {
	const { t } = useTranslation();

	return (
		<div id="skills">
			<Title>{t("skills")}</Title>
			{/* max-lg:grid-cols-9 */}
			<div className="grid grid-cols-6 max-md:grid-cols-6 max-sm:grid-cols-3 gap-y-8">
				{SHOW_SKILLS.map(
					(name) =>
						[name, (skills as { [name: string]: Skill })[name]] as [
							string,
							Skill,
						],
				).map(([name, { icon, link, title }]) => {
					if (!title) {
						title = capitalize(name);
					}

					return (
						<a
							href={link}
							className="text-center text-wrap break-words"
							key={name}
						>
							<img
								className="mx-auto size-16"
								src={`imgs/icons/${icon}.svg`}
								alt={title}
							></img>
							{title}
						</a>
					);
				})}
			</div>
		</div>
	);
}
